'use client'

import { useAuth } from '@/lib/auth/AuthProvider'
import { usePathname } from 'next/navigation'


export default function ConditionalBackground() {
  const { user, isPhoneVerified, isLoading } = useAuth()
  const pathname = usePathname()

  // Check if current page is an auth page
  const isAuthPage = pathname?.startsWith('/login') || 
                    pathname?.startsWith('/register') ||
                    pathname?.startsWith('/verify-phone') ||
                    pathname?.startsWith('/auth/')

  // Only show 3D stadium background if:
  // 1. User is fully authenticated (logged in AND phone verified)
  // 2. Not on auth pages
  // 3. Not loading
  const shouldShow3DBackground = !isLoading && 
                                user && 
                                isPhoneVerified && 
                                !isAuthPage



  // For auth pages or non-authenticated users, no global background
  // (auth pages will have their own AuthBackground)
  return null
}